import './specimen-edit-screen-header.scss'

import { defineComponent, PropType } from 'vue';

import { SpecimenResource } from '@skinsoft/types';
import { specimenSelectors } from '@skinsoft/selectors';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { Media } from '@skinsoft/ui/src/item-card/media';

export const SpecimenEditScreenHeader = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sMedia: Media,
    },
    props: {
        specimen: {
            type: Object as PropType<SpecimenResource>,
            required: true
        },
        actionsAvailable: {
            type: Boolean,
            default: false,
        },
    },
    template: require('./specimen-edit-screen-header.html'),
    computed: {
        mediaId() {
            return specimenSelectors.firstMediaId(this.specimen)
        },

        firstIdentifier(): string {
            return specimenSelectors.firstIdentifier(this.specimen) ?? ""
        },

        title() {
            return specimenSelectors.title(this.specimen, this.getAppLocale()) ?? ""
        },

        isOfflineItem() {
            return !window.navigator.onLine || !!this.specimen?.id?.startsWith('_')
        },
    }
})
